import React, { useState, useEffect } from "react";
import { calcTotalChips, getChallengeWordsTable } from "./container";
import {
  LineShareButton,
  TwitterShareButton,
  LineIcon,
  TwitterIcon,
} from "react-share";
import { Box, Button } from "@mui/material";
import { ChipIcon } from "components/icons/ChipIcon";
import ReactGA from "react-ga4";
// import REACT_APP_MAIN_URL from "../../constant";

interface props {
  timesOfAnswers: number;
  lostChars: string[];
  challengeWords: string[];
  challengeIndex: string;
  pagesTotal: number;
}

const ResultModal: React.FC<props> = ({
  timesOfAnswers,
  lostChars,
  challengeWords,
  challengeIndex,
  pagesTotal,
}) => {
  const [isTiming, setIsTiming] = useState(false);
  const todayInstance = new Date();
  const today =
    todayInstance.getFullYear() +
    "年" +
    (todayInstance.getMonth() + 1) +
    "月" +
    todayInstance.getDate() +
    "日";
  const timesOfAnswersPadStart = timesOfAnswers.toString().padStart(3, "0");
  const totalChips = calcTotalChips(lostChars);
  const totalChipsPadStart = totalChips.toString().padStart(3, "0");
  const timesOfMistake = timesOfAnswers - totalChips;
  const challengeWordsTable = getChallengeWordsTable(challengeWords);
  const messageForComp =
    timesOfMistake === 0
      ? "パーフェクト正解！"
      : `${timesOfMistake.toString().padStart(3, "0")}文字のミス！`;
  const shareMessage = `あいうえパズル もんだい${(Number(challengeIndex) + 1)
    .toString()
    .padStart(
      3,
      "0"
    )}\n${messageForComp}  \n${totalChipsPadStart}文字を${timesOfAnswersPadStart}回でクリア！ ${challengeWordsTable}\n#あいうえパズル\n詳細リンク：`;
  // const appLink = REACT_APP_MAIN_URL;
  const appLink = "https://aiue-puzzle.netlify.app/";

  const reload = () => {
    const nextChallengeIndex = (
      (Number(challengeIndex) + 1) %
      pagesTotal
    ).toString();
    localStorage.setItem("ChallengeIndex", nextChallengeIndex);
    window.location.reload();
  };

  useEffect(() => {
    //アニメーションの後に結果を表示
    setTimeout(() => {
      setIsTiming(true);
    }, 4000);
  }, []);

  const toAmazon = () => {
    const path = "https://amzn.to/3WVj5oP";
    ReactGA.event("page_link1", { path });
    window.location.href = path;
  };

  return (
    <>
      {isTiming && (
        <Box
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0,0,0,0.5)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 1000,
            fontFamily: "yasashisa",
          }}
        >
          <Box
            style={{
              zIndex: 2,
              width: "75%",
              height: "60%",
              maxWidth: "600px",
              maxHeight: "350px",
              background: "#fff",
              borderRadius: 8,
            }}
          >
            <Box
              p={1}
              fontSize={18}
              fontWeight="bold"
              textAlign="center"
              bgcolor="rgba(255, 255, 0, .3)"
              borderRadius="8px 8px 0 0"
            >
              Congratulations!
            </Box>
            <Box
              position="relative"
              height="calc(100% - 59px)"
              p={1}
              textAlign="center"
            >
              <Box>
                <strong>あいうえパズル</strong>{" "}
                <span style={{ fontSize: 12 }}>
                  もんだい
                  {(Number(challengeIndex) + 1).toString().padStart(3, "0")}
                </span>
              </Box>
              <Box fontSize={14}>{today}</Box>
              <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                mt={2}
              >
                <Box mr={1}>
                  <ChipIcon width={20} />
                </Box>
                <Box>チップ</Box>
              </Box>
              <Box
                display="flex"
                justifyContent="center"
                alignItems="flex-end"
                mx={-1}
                pt={1}
                pb={2}
                bgcolor="#eee"
              >
                <Box
                  position="relative"
                  fontSize={32}
                  fontWeight="bold"
                  color="magenta"
                >
                  {timesOfAnswersPadStart}
                  <Box
                    position="absolute"
                    sx={{
                      left: { xs: -18, md: -19 },
                      bottom: { xs: -8, md: -10 },
                    }}
                    fontSize={10}
                    width="100px"
                  >
                    置いた数
                  </Box>
                </Box>
                <Box position="relative" mb={1} ml={1}>
                  /{" " + totalChipsPadStart}
                  <Box
                    display="flex"
                    position="absolute"
                    sx={{
                      left: 3,
                      bottom: { xs: -15, md: -12 },
                    }}
                    fontSize={10}
                    width="100px"
                  >
                    <Box ml={1}>必要な数</Box>
                  </Box>
                </Box>
              </Box>
              <Box
                position="absolute"
                // left="calc(50% - 90px)"
                bottom={64}
                textAlign="center"
                sx={{
                  left: { xs: "calc(50% - 120px)", md: "calc(50% - 160px)" },
                }}
              >
                <Button
                  variant="contained"
                  color="warning"
                  startIcon={"▶"}
                  onClick={reload}
                >
                  別の問題に挑戦する
                </Button>
                <Box mt={1} sx={{ fontSize: { xs: 12, md: 16.5 } }}>
                  <Box
                    onClick={toAmazon}
                    style={{ cursor: "pointer", textDecoration: "underline" }}
                    color="#1976d2"
                  >
                    「あいうえパズル」（Amazon公式サイト）
                  </Box>
                </Box>
              </Box>
              <Box
                display="flex"
                alignItems="center"
                position="absolute"
                left={0}
                bottom={0}
                width="100%"
                mx="auto"
                bgcolor="#eee"
                borderRadius="0 0 4px 4px"
                fontSize={14}
                textAlign="center"
              >
                <Box
                  py={2}
                  bgcolor="rgba(255, 128, 0, .8)"
                  color="#fff"
                  fontWeight="bold"
                  borderRadius="0 32px 32px 4px"
                  sx={{
                    px: { xs: 2, md: 8 },
                  }}
                >
                  SNSでシェア
                </Box>
                <Box display="flex" alignItems="center">
                  <TwitterShareButton
                    url={appLink}
                    title={shareMessage}
                    style={{ margin: "4px 12px 0 40px" }}
                  >
                    <TwitterIcon size={32} round />
                  </TwitterShareButton>
                  <LineShareButton
                    url={appLink}
                    title={shareMessage}
                    style={{ marginTop: 4 }}
                  >
                    <LineIcon size={32} round />
                  </LineShareButton>
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>
      )}
    </>
  );
};

export default ResultModal;
